import React, { Fragment } from "react";
import { useSelector } from "react-redux";

import { EcornerService } from "@services/eCorner.service";

import * as CustomerModule from "@redux/modules/api/data/customer/customer.module";
import * as OrderDetailsSelectors from "@redux/modules/api/data/orderDetail/orderDetail.selectors";
import { broadcastMessage } from "@redux/modules/value/messages/messages.utils";
import { useThunkDispatch } from "@redux/dispatcher";

import LogoutButton from "./logoutButton.component";
import { hasWindow } from "@utils/general";

type Props = {
    text: string;
    message: string;
    target: string;
};

const LogoutButtonContainer = ({ text, message, target }: Props) => {
    const dispatch = useThunkDispatch();
    const order = useSelector(OrderDetailsSelectors.getOrder);

    const customer = order?.customer;

    const onLogout = () => {
        dispatch(CustomerModule.logout()).then(action => {
            if (action.type === CustomerModule.APIStatus.SUCCESS) {
                broadcastMessage({
                    id: target,
                    text: message,
                    status: "success",
                    dismissible: false,
                });

                const element = hasWindow()
                    ? document?.querySelector(`div[data-messageid="${target}"]`)
                    : undefined;

                if (element) {
                    element.scrollIntoView({
                        behavior: "smooth",
                        block: "center",
                        inline: "center",
                    });
                }
            }
        });
    };

    return (
        <Fragment>
            {!EcornerService.isEcornerEnvironment() &&
                customer &&
                !customer.guest && (
                    <LogoutButton text={text} logout={onLogout} />
                )}
        </Fragment>
    );
};

export { LogoutButtonContainer };
